import API from './base';

class ExamSearchResultApi extends API {
  getSlots = (latitude, longitude, date) => {
    const examCentersQueryParams = new URLSearchParams({
      latitude,
      longitude,
      date,
    });

    return this.get('/api/web/v1/slots', examCentersQueryParams);
  };
}

export default new ExamSearchResultApi();
